var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vpn-home"},[_c('HeadNav',{attrs:{"selected-language":"en","page":"home"}}),_vm._v(" "),_c('main',[_c('HomeSections')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }